/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as runtime from '../runtime';
import { CreateDataMappingRequestToJSON, ExportConfigurationRepresentationFromJSON, UpdateDataMappingRequestToJSON, } from '../models';
/**
 *
 */
var ExportConfigurationsApi = /** @class */ (function (_super) {
    __extends(ExportConfigurationsApi, _super);
    function ExportConfigurationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Add configuration for an export
     */
    ExportConfigurationsApi.prototype.createRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createDataMappingRequest === null ||
                            requestParameters.createDataMappingRequest === undefined) {
                            throw new runtime.RequiredError('createDataMappingRequest', 'Required parameter requestParameters.createDataMappingRequest was null or undefined when calling create.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/exportConfiguration",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: CreateDataMappingRequestToJSON(requestParameters.createDataMappingRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return ExportConfigurationRepresentationFromJSON(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Add configuration for an export
     */
    ExportConfigurationsApi.prototype.create = function (createDataMappingRequest) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createRaw({ createDataMappingRequest: createDataMappingRequest })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get template for given export configuration by id
     */
    ExportConfigurationsApi.prototype.downloadTemplateRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.exportConfigurationId === null || requestParameters.exportConfigurationId === undefined) {
                            throw new runtime.RequiredError('exportConfigurationId', 'Required parameter requestParameters.exportConfigurationId was null or undefined when calling downloadTemplate.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/exportConfiguration/{exportConfigurationId}/template".replace("{".concat('exportConfigurationId', "}"), encodeURIComponent(String(requestParameters.exportConfigurationId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Get template for given export configuration by id
     */
    ExportConfigurationsApi.prototype.downloadTemplate = function (exportConfigurationId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadTemplateRaw({ exportConfigurationId: exportConfigurationId })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Fetch export configuration by id
     */
    ExportConfigurationsApi.prototype.getByIdRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.exportConfigurationId === null || requestParameters.exportConfigurationId === undefined) {
                            throw new runtime.RequiredError('exportConfigurationId', 'Required parameter requestParameters.exportConfigurationId was null or undefined when calling getById.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/exportConfiguration/{exportConfigurationId}".replace("{".concat('exportConfigurationId', "}"), encodeURIComponent(String(requestParameters.exportConfigurationId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return ExportConfigurationRepresentationFromJSON(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Fetch export configuration by id
     */
    ExportConfigurationsApi.prototype.getById = function (exportConfigurationId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getByIdRaw({ exportConfigurationId: exportConfigurationId })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Find all export configurations
     */
    ExportConfigurationsApi.prototype.listRaw = function () {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/exportConfiguration",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return jsonValue.map(ExportConfigurationRepresentationFromJSON);
                            })];
                }
            });
        });
    };
    /**
     * Find all export configurations
     */
    ExportConfigurationsApi.prototype.list = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Add configuration for an export
     */
    ExportConfigurationsApi.prototype.patchRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.exportConfigurationId === null || requestParameters.exportConfigurationId === undefined) {
                            throw new runtime.RequiredError('exportConfigurationId', 'Required parameter requestParameters.exportConfigurationId was null or undefined when calling patch.');
                        }
                        if (requestParameters.updateDataMappingRequest === null ||
                            requestParameters.updateDataMappingRequest === undefined) {
                            throw new runtime.RequiredError('updateDataMappingRequest', 'Required parameter requestParameters.updateDataMappingRequest was null or undefined when calling patch.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/exportConfiguration/{exportConfigurationId}".replace("{".concat('exportConfigurationId', "}"), encodeURIComponent(String(requestParameters.exportConfigurationId))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: UpdateDataMappingRequestToJSON(requestParameters.updateDataMappingRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return ExportConfigurationRepresentationFromJSON(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Add configuration for an export
     */
    ExportConfigurationsApi.prototype.patch = function (exportConfigurationId, updateDataMappingRequest) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchRaw({
                            exportConfigurationId: exportConfigurationId,
                            updateDataMappingRequest: updateDataMappingRequest,
                        })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete export configuration
     */
    ExportConfigurationsApi.prototype.removeRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.exportConfigurationId === null || requestParameters.exportConfigurationId === undefined) {
                            throw new runtime.RequiredError('exportConfigurationId', 'Required parameter requestParameters.exportConfigurationId was null or undefined when calling remove.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/exportConfiguration/{exportConfigurationId}".replace("{".concat('exportConfigurationId', "}"), encodeURIComponent(String(requestParameters.exportConfigurationId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete export configuration
     */
    ExportConfigurationsApi.prototype.remove = function (exportConfigurationId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeRaw({ exportConfigurationId: exportConfigurationId })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Upload template xlsx file
     */
    ExportConfigurationsApi.prototype.uploadTemplateRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.exportConfigurationId === null || requestParameters.exportConfigurationId === undefined) {
                            throw new runtime.RequiredError('exportConfigurationId', 'Required parameter requestParameters.exportConfigurationId was null or undefined when calling uploadTemplate.');
                        }
                        if (requestParameters.template === null || requestParameters.template === undefined) {
                            throw new runtime.RequiredError('template', 'Required parameter requestParameters.template was null or undefined when calling uploadTemplate.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        consumes = [{ contentType: 'multipart/form-data' }];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        // use FormData to transmit files using content-type "multipart/form-data"
                        useForm = canConsumeForm;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.template !== undefined) {
                            formParams.append('template', requestParameters.template);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/exportConfiguration/{exportConfigurationId}/template".replace("{".concat('exportConfigurationId', "}"), encodeURIComponent(String(requestParameters.exportConfigurationId))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return ExportConfigurationRepresentationFromJSON(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Upload template xlsx file
     */
    ExportConfigurationsApi.prototype.uploadTemplate = function (exportConfigurationId, template) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.uploadTemplateRaw({
                            exportConfigurationId: exportConfigurationId,
                            template: template,
                        })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ExportConfigurationsApi;
}(runtime.BaseAPI));
export { ExportConfigurationsApi };
